import api from "./api";

export async function listRoteiros({ incluirCancelados = false } = {}) {
  const { data } = await api.get("/Roteiros", {
    params: incluirCancelados ? { incluirCancelados: true } : undefined,
  });
  return data;
}

export async function getRoteiro(id) {
  const { data } = await api.get(`/Roteiros/${id}`);
  return data;
}

export async function createRoteiro(payload) {
  const { data } = await api.post("/Roteiros", payload);
  return data;
}

export async function updateRoteiro(id, payload) {
  await api.put(`/Roteiros/${id}`, payload);
}

export async function deleteRoteiro(id) {
  await api.delete(`/Roteiros/${id}`);
}

// Cancela um roteiro (qualquer status). Preserva parcelas pagas como
// histórico de receita; libera agenda e apaga parcelas não-pagas.
export async function cancelarRoteiro(id) {
  await api.post(`/Roteiros/${id}/cancelar`);
}

// Reativa um roteiro cancelado — volta pra Rascunho. Financeiro/agenda
// não são recriados automaticamente; precisa abrir o form pra reconfirmar.
export async function reativarRoteiro(id) {
  await api.post(`/Roteiros/${id}/reativar`);
}

// Duplica um roteiro como template pra novo grupo. Retorna o novo (Rascunho,
// sem cliente). Dias e tarefas vêm copiados; tarefas voltam pra Pendente sem
// data de vencimento. Documentos anexados NÃO são copiados.
export async function duplicarRoteiro(id) {
  const { data } = await api.post(`/Roteiros/${id}/duplicar`);
  return data;
}

// Duplica como IRMÃO do original — mesma viagem física, contrato separado.
// Mantém DataInicio/DataFim do original (não ajusta) e propaga GrupoId nos 2
// (cria novo Guid se original ainda era standalone). Novo nasce Rascunho.
export async function duplicarComoGrupo(id) {
  const { data } = await api.post(`/Roteiros/${id}/duplicar-como-grupo`);
  return data;
}

// Candidatos pra vincular ao roteiro-âncora num grupo. Heurística: mesmo
// cliente (ordenado antes) ou datas próximas (±30 dias).
export async function listCandidatosGrupo(id) {
  const { data } = await api.get(`/Roteiros/${id}/candidatos-grupo`);
  return data;
}

// Vincula (passa outroId) ou desvincula (null) do grupo.
export async function patchGrupoRoteiro(id, vincularAoRoteiroId) {
  await api.patch(`/Roteiros/${id}/grupo`, {
    vincularAoRoteiroId: vincularAoRoteiroId,
  });
}

export async function listDias(roteiroId) {
  const { data } = await api.get(`/roteiros/${roteiroId}/dias`);
  return data;
}

// Busca o PDF do roteiro como Blob. Base comum dos dois fluxos: download e
// visualização inline em nova aba. O axios interceptor em api.js injeta o
// Authorization: Bearer automaticamente em toda request.
//
// options (opcional): { passageiros, dias, valores } — omitir mantém default
// backend (tudo true, retro-compat).
export async function fetchRoteiroPdfBlob(id, options) {
  const params = options
    ? {
        passageiros: options.passageiros,
        dias: options.dias,
        valores: options.valores,
      }
    : undefined;
  const res = await api.get(`/Roteiros/${id}/pdf`, {
    responseType: "blob",
    params,
  });
  return res.data;
}

// Gera e baixa o PDF do roteiro. O backend persiste em {STORAGE_PATH}/pdfs/
// e devolve o arquivo; aqui disparamos o download nativo do browser.
export async function downloadRoteiroPdf(id, nomeSugerido, options) {
  const blob = await fetchRoteiroPdfBlob(id, options);
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = nomeSugerido || `roteiro-${id}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export async function createDia(roteiroId, payload) {
  const { data } = await api.post(`/roteiros/${roteiroId}/dias`, payload);
  return data;
}
